import type { ReactNode } from 'react';

interface TermsConsentGateProps {
  children: ReactNode;
}

export default function TermsConsentGate({ children }: TermsConsentGateProps) {
  // No-op: sempre renderiza os filhos, sem bloquear por consentimento.
  return <>{children}</>;
}
